enum TripLegStatus {
  Draft = 'draft',
  OnHold = 'onhold',
  Open = 'open',
  Offered = 'offered',
  Accepted = 'accepted',
  Confirmed = 'confirmed',
  Onsite = 'onsite',
  Onboard = 'onboard',
  Canceled = 'canceled',
  NoLoad = 'noload',
  Completed = 'completed',
  Denied = 'denied',
  Abandoned = 'abandoned',
  Void = 'void',
  InTransit = 'driverintransit',
  CanceledLate = 'canceledlate',
  Dropoff = 'dropoff',
}

enum TripLegStatusBC {
  Draft = 'DRAFT',
  OnHold = 'ONHOLD',
  Open = 'OPEN',
  Offered = 'OFFERED',
  Accepted = 'ACCEPTED',
  Confirmed = 'CONFIRMED',
  Onsite = 'ONSITE',
  Onboard = 'ONBOARD',
  Canceled = 'CANCELED',
  NoLoad = 'NOLOAD',
  Completed = 'COMPLETED',
  Denied = 'DENIED',
  Abandoned = 'ABANDONED',
  Void = 'VOID',
  InTransit = 'DRIVERINTRANSIT',
  CanceledLate = 'CANCELEDLATE',
  Dropoff = 'DROPOFF',
  NoPassenger = 'NOPASSENGER',
  NoPassengerForDriver = 'NOPASSENGERFORDRIVER',
}

enum TripLegStatusF1CloudString {
  Accepted = 'accepted',
  Onsite = 'onsite',
  Onboard = 'onboard',
  NoLoad = 'noload',
  Completed = 'dropoff',
  InTransit = 'onmyway',
  CanceledLate = 'quit',
}

const tripStatusBillableList: TripLegStatusBC[] = [
  TripLegStatusBC.Completed,
  TripLegStatusBC.NoLoad,
  TripLegStatusBC.CanceledLate,
];

const tripStatusCompletedList: TripLegStatusBC[] = [
  TripLegStatusBC.Completed,
  TripLegStatusBC.NoLoad,
  TripLegStatusBC.CanceledLate,
];

const tripStatusAttestationListTier3: TripLegStatusBC[] = [
  TripLegStatusBC.Accepted,
  TripLegStatusBC.Onsite,
  TripLegStatusBC.Onboard,
  TripLegStatusBC.Completed,
  TripLegStatusBC.NoLoad,
  TripLegStatusBC.CanceledLate,
];

const tripStatusAttestationList: TripLegStatusBC[] = [
  TripLegStatusBC.Accepted,
  TripLegStatusBC.Confirmed,
  TripLegStatusBC.Onsite,
  TripLegStatusBC.Onboard,
  ...tripStatusCompletedList,
];

const tripStatusNoLoadList: TripLegStatusBC[] = [
  TripLegStatusBC.NoLoad,
  TripLegStatusBC.NoPassengerForDriver,
];

const statusProgressionOrder: TripLegStatusBC[] = [
  TripLegStatusBC.Accepted,
  TripLegStatusBC.Confirmed,
  TripLegStatusBC.Onsite,
  TripLegStatusBC.Onboard,
  TripLegStatusBC.Completed,
];

export const hasReachedStatus = (
  currentStatus: TripLegStatusBC,
  targetStatus: TripLegStatusBC,
): boolean => {
  if (
    currentStatus === TripLegStatusBC.NoLoad ||
    currentStatus === TripLegStatusBC.CanceledLate
  ) {
    return true;
  }

  if (
    targetStatus === TripLegStatusBC.NoLoad ||
    targetStatus === TripLegStatusBC.CanceledLate
  ) {
    const currentIndex = statusProgressionOrder.indexOf(currentStatus);
    const onsiteIndex = statusProgressionOrder.indexOf(TripLegStatusBC.Onsite);
    return currentIndex >= onsiteIndex;
  }

  const currentIndex = statusProgressionOrder.indexOf(currentStatus);
  const targetIndex = statusProgressionOrder.indexOf(targetStatus);

  if (currentIndex === -1 || targetIndex === -1) {
    return false;
  }

  return currentIndex >= targetIndex;
};

const tripStatusActiveList: TripLegStatusBC[] = [
  TripLegStatusBC.Offered,
  TripLegStatusBC.Accepted,
  TripLegStatusBC.Confirmed,
  TripLegStatusBC.Onsite,
  TripLegStatusBC.Onboard,
  TripLegStatusBC.InTransit,
];

export {
  tripStatusBillableList,
  tripStatusCompletedList,
  tripStatusAttestationList,
  tripStatusAttestationListTier3,
  tripStatusNoLoadList,
  TripLegStatus,
  TripLegStatusBC,
  TripLegStatusF1CloudString,
  tripStatusActiveList,
};
